document.addEventListener("DOMContentLoaded", () => {

  /* ---------- ELEMENTS ---------- */

  const step1 = document.getElementById("step1");
  const step2 = document.getElementById("step2");
  const step3 = document.getElementById("step3");

  const success  = document.getElementById("success");
  const progress = document.querySelector("#progressBar");

  const steps = [step1, step2, step3];

  /* Inputs */
  const first          = document.getElementById("first");
  const last           = document.getElementById("last");
  const email          = document.getElementById("email");
  const phone          = document.getElementById("phone");
  const business       = document.getElementById("business");
  const company        = document.getElementById("company");
  const numberOfStores = document.getElementById("stores");
  const street         = document.getElementById("street");
  const city           = document.getElementById("city");
  const postal         = document.getElementById("postal");
  const country        = document.getElementById("country");
  const provinceSelect = document.getElementById("provinceSelect");
  // const provinceInput  = document.getElementById("provinceInput");
  const comments       = document.getElementById("comments");
  const reviewBox      = document.getElementById("reviewBox");

  /* Buttons */
  const next1      = document.getElementById("next1");
  const back1      = document.getElementById("back1");
  const reviewBtn  = document.getElementById("reviewBtn");
  const edit       = document.getElementById("edit");
  const submitBtn  = document.getElementById("submit");
  const resetBtn   = document.getElementById("ww_reset_btn");


  /* ---------- STEP CONTROL ---------- */

  function setStep(i) {
    steps.forEach((s, x) => s.classList.toggle("hidden", x !== i));
    progress.style.width = (i + 1) * 33 + "%";
  }


  /* ---------- ERROR UI ---------- */

  function showError(input, msg) {
    if (!input) return;
    const container = input.closest(".ww-field");
    if (!container) return;
    let e = container.querySelector(".error-text");
    if (!e) {
      e = document.createElement("div");
      e.className = "error-text";
      container.appendChild(e);
    }
    e.textContent = msg;
    e.classList.add("show");
    input.classList.add("input-error");
  }

  function clearError(input) {
    const container = input.closest(".ww-field");
    if (!container) return;
    const e = container.querySelector(".error-text");
    if (e) e.classList.remove("show");
    input.classList.remove("input-error");
  }

  function clearAllErrors() {
    document.querySelectorAll(".error-text").forEach(e => e.classList.remove("show"));
    document.querySelectorAll(".input-error").forEach(e => e.classList.remove("input-error"));
  }


  /* ---------- PHONE FORMAT ---------- */

  phone.addEventListener("input", () => {
    let v = phone.value.replace(/\D/g, "").slice(0, 10);
    if (v.length > 6)      phone.value = `(${v.slice(0,3)}) ${v.slice(3,6)}-${v.slice(6)}`;
    else if (v.length > 3) phone.value = `(${v.slice(0,3)}) ${v.slice(3)}`;
    else                   phone.value = v;
  });


  /* ---------- POSTAL FORMAT ---------- */

  postal.addEventListener("input", () => {
    let v = postal.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
    if (v.length > 3) v = v.slice(0, 3) + " " + v.slice(3);
    postal.value = v;
  });


  /* ---------- CANADA LOGIC ---------- */

  // country.addEventListener("input", () => {
  //   if (country.value.trim().toLowerCase() === "canada") {
  //     provinceSelect.classList.remove("hidden");
  //     provinceInput.classList.add("hidden");
  //   } else {
  //     provinceSelect.classList.add("hidden");
  //     provinceInput.classList.remove("hidden");
  //   }
  // });

  function getProvince() {
    // return country.value.trim().toLowerCase() === "canada"
    //   ? provinceSelect.value
    //   : provinceInput.value;
    return provinceSelect.value;
  }


  /* ---------- VALIDATION ---------- */

  const textRule   = /^[\p{L}\s.\-']{3,}$/u;
  const streetRule = /^(?=.*[a-zA-Z])(?=.*\d).{5,}$/;
  const caPostal   = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  function validateStep1() {
    let ok = true;
    [first, last, email, phone].forEach(clearError);

    if (!textRule.test(first.value)) {
      showError(first, "Enter real first name");
      ok = false;
    }

    if (!textRule.test(last.value)) {
      showError(last, "Enter real last name");
      ok = false;
    }

    if (!email.value.match(/^\S+@\S+\.\S+$/)) {
      showError(email, "Enter valid email");
      ok = false;
    }

    if (phone.value.replace(/\D/g, "").length < 10) {
      showError(phone, "Enter valid phone");
      ok = false;
    }

    return ok;
  }

  function validateStep2() {
    let ok = true;
    [business, company, street, city, country, postal].forEach(clearError);
    clearError(provinceSelect);
    // clearError(provinceInput);

    if (!business.value) {
      showError(business, "Select business type");
      ok = false;
    }

    if (company.value.trim().length < 2) {
      showError(company, "Enter real company");
      ok = false;
    }

    if (!streetRule.test(street.value)) {
      showError(street, "Street must include number + name");
      ok = false;
    }

    if (!textRule.test(city.value)) {
      showError(city, "Enter real city");
      ok = false;
    }

    if (!textRule.test(country.value)) {
      showError(country, "Enter real country");
      ok = false;
    }

    if (country.value.trim().toLowerCase() === "canada") {

      if (!provinceSelect.value) {
        showError(provinceSelect, "Select province");
        ok = false;
      }

      if (!caPostal.test(postal.value)) {
        showError(postal, "Invalid Canadian postal");
        ok = false;
      }

    } else {
      if (postal.value.trim().length < 3) {
        showError(postal, "Enter postal code");
        ok = false;
      }
    }

    return ok;
  }


  /* ---------- DATA ---------- */

  function data() {
    return {
      first:          first.value,
      last:           last.value,
      email:          email.value,
      phone:          phone.value,
      business:       business.value,
      company:        company.value,
      numberOfStores: numberOfStores.value,
      street:         street.value,
      city:           city.value,
      country:        country.value,
      province:       getProvince(),
      postal:         postal.value,
      comments:       comments.value
    };
  }

  // Force dark background on all selects
    function updateSelectColor(select) {
      select.style.setProperty('background', '#000000', 'important');
      select.style.setProperty('color',
        select.value === '' ? 'rgba(255,255,255,0.40)' : 'rgba(255,255,255,0.90)',
        'important'
      );
    }

    document.querySelectorAll('.ww-field select').forEach(function (select) {
      updateSelectColor(select);
      select.addEventListener('change', function () { updateSelectColor(select); });
    });

    function buildWwDropdown(selectEl) {
      const wrapper = selectEl.closest('.ww-field');
      if (!wrapper || wrapper.dataset.customDropdown) return;
      wrapper.dataset.customDropdown = 'true';
      wrapper.style.position = 'relative';

      const display = document.createElement('div');
      display.className = 'ww-custom-dropdown__display';

      function syncDisplay() {
        const selected = selectEl.options[selectEl.selectedIndex];
        display.textContent = selected ? selected.text : '';
        display.style.color = (!selectEl.value || selectEl.value === '')
          ? 'rgba(255,255,255,0.40)'
          : 'rgba(255,255,255,0.90)';
      }
      syncDisplay();

      const listEl = document.createElement('div');
      listEl.className = 'ww-dropdown-list hidden';

      function buildOptions() {
        listEl.innerHTML = '';
        Array.from(selectEl.options).forEach(function (opt) {
          const item = document.createElement('div');
          item.className = 'ww-dropdown-option';
          item.textContent = opt.text;
          item.addEventListener('mousedown', function (e) {
            e.preventDefault();
            selectEl.value = opt.value;
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
            syncDisplay();
            listEl.classList.add('hidden');
          });
          listEl.appendChild(item);
        });
      }
      buildOptions();

      display.addEventListener('click', function (e) {
        e.stopPropagation();
        const isHidden = listEl.classList.contains('hidden');
        document.querySelectorAll('.ww-dropdown-list').forEach(d => d.classList.add('hidden'));
        if (isHidden) listEl.classList.remove('hidden');
      });

      document.addEventListener('click', function () {
        listEl.classList.add('hidden');
      });

      new MutationObserver(function () {
        buildOptions();
        syncDisplay();
      }).observe(selectEl, { childList: true });

      selectEl.style.display = 'none';
      wrapper.insertBefore(display, selectEl);
      wrapper.appendChild(listEl);

      selectEl.addEventListener('change', function () {
        syncDisplay();
      });
    }

    document.querySelectorAll('.ww-field select').forEach(function (select) {
      buildWwDropdown(select);
    });

  /* ---------- REVIEW ---------- */

  function review() {
    const labels = {
      first:          "First Name",
      last:           "Last Name",
      email:          "Email",
      phone:          "Phone",
      business:       "Business Type",
      company:        "Company Name",
      numberOfStores: "Number of Stores",
      street:         "Street Address",
      city:           "City",
      country:        "Country",
      province:       "Province / State",
      postal:         "Postal Code",
      comments:       "Comments"
    };

    reviewBox.innerHTML = Object.entries(data())
      .map(([k, v]) => `<div><b>${labels[k] || k}</b>: ${v || "—"}</div>`)
      .join("");
  }


  /* ---------- NAV ---------- */

  next1.onclick = () => {
    if (validateStep1()) setStep(1);
  };

  back1.onclick = () => setStep(0);

  reviewBtn.onclick = () => {
    if (validateStep2()) {
      review();
      setStep(2);
    }
  };

  // edit.onclick = () => setStep(0);
  edit.onclick = () => setStep(1);


  /* ---------- SUBMIT ---------- */

  const RemoteUrl = 'https://emailservice.nashavape.com/api/email/send/wholesale-request';

  submitBtn.addEventListener("click", function () {

    clearAllErrors();

    const btn = submitBtn.querySelector("button") || submitBtn;
    btn.disabled = true;
    btn.textContent = "Submitting...";

    if (!validateStep1() || !validateStep2()) {
      btn.disabled = false;
      btn.textContent = "Submit";
      return;
    }

    const NA = "N/A";
    const d  = data();

    const formData = new FormData();
    formData.append("FromEmail", "internal@thevapebusiness.com");
    formData.append("ToEmail",   "signups@thevapebusiness.com");
    formData.append("source",   "Nasha");
    formData.append("FirstName",      d.first.trim()          || NA);
    formData.append("LastName",       d.last.trim()           || NA);
    formData.append("Email",          d.email.trim()          || NA);
    formData.append("Phone",          d.phone.trim()          || NA);
    formData.append("BusinessType",   d.business              || NA);
    formData.append("CompanyName",    d.company.trim()        || NA);
    formData.append("NumberOfStores", (d.numberOfStores || "").trim() || NA);
    formData.append("StreetAddress",  d.street.trim()         || NA);
    formData.append("City",           d.city.trim()           || NA);
    formData.append("PostalCode",     d.postal.trim()         || NA);
    formData.append("Country",        d.country.trim()        || NA);
    formData.append("Province",       d.province.trim()       || NA);
    formData.append("Comments",       d.comments.trim()       || "No comments provided.");

    /* ---------- SEND TO BXRS (readable labels) ---------- */
    var bxrsFields = {
      "First name":       d.first.trim()                    || NA,
      "Last name":        d.last.trim()                     || NA,
      "Email":            d.email.trim()                    || NA,
      "Phone":            d.phone.trim()                    || NA,
      "Business type":    d.business                        || NA,
      "Company name":     d.company.trim()                  || NA,
      "Number of stores": (d.numberOfStores || "").trim()   || NA,
      "Street address":   d.street.trim()                   || NA,
      "City":             d.city.trim()                     || NA,
      "Province":         d.province.trim()                 || NA,
      "Postal code":      d.postal.trim()                   || NA,
      "Country":          d.country.trim()                  || NA,
      "Comments":         d.comments.trim()                 || "No comments provided."
    };


    fetch('https://bxrs.ca/api/wholesale/submit', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'X-Wholesale-Key': 'bf8f6ac654f16ed5e77f62f303381827b8fdcdada6c7c40c' },
  body: JSON.stringify({ fields: bxrsFields, page: location.href }),
}).catch(function () {});
  
    fetch(RemoteUrl, { method: "POST", body: formData })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (body) {
            throw new Error("Server error " + response.status + ": " + body);
          });
        }
        return response.text();
      })
      .then(function () {
        step1.classList.add("hidden");
        step2.classList.add("hidden");
        step3.classList.add("hidden");
        success.classList.remove("hidden");
        progress.style.width = "100%";
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch(function (error) {
        console.error("Submission error:", error.message);
        alert("Submission failed: " + error.message);
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = "Submit";
      });

  });
  /* ---------- RESET / RE-OPEN ---------- */

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      // Clear all text inputs and textareas
      document.querySelectorAll(".ww-card input, .ww-card textarea").forEach(function (el) {
        el.value = "";
      });

      // Reset selects to their placeholder and re-sync the custom dropdowns.
      // selectedIndex change doesn't fire 'change' on its own, so dispatch it.
      document.querySelectorAll(".ww-card select").forEach(function (sel) {
        sel.selectedIndex = 0;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      });

      clearAllErrors();

      // Re-gate the province field
      if (provinceSelect) provinceSelect.classList.add("hidden");

      // Back to step 1
      success.classList.add("hidden");
      setStep(0);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

});